module.exports = __webpack_public_path__ + "media/hyper/images/report-58b7b2a2e920ea89cc31b5e18be4d987.svg";